import styles from "./Carousel.module.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import SwiperCore, { Autoplay } from "swiper";
SwiperCore.use([Autoplay]);

const Carousel = (props) => {
  return (
    <section className={`${styles.section} ${props.className}`}>
      {props.title && <h2 className={styles.title}>{props.title}</h2>}
      <Swiper
        slidesPerView={1.4}
        spaceBetween={0}
        breakpoints={{
          450: {
            slidesPerView: 3,
            spaceBetween: 0,
          },
        }}
        centeredSlides={true}
        loop={true}
        speed={3000}
        autoplay={{
          delay: 1,
          disableOnInteraction: false,
        }}
        className="mySwiper"
      >
        {props.data.map((item) => {
          return (
            <SwiperSlide key={item.id}>
              <img className={styles.img} src={item.img} alt={item.alt} />
            </SwiperSlide>
          );
        })}
      </Swiper>
    </section>
  );
};

export default Carousel;
